import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe } from '@codeandweb/ngx-translate';
import { AppService } from '../../../services/app.service';
import { HistoryItem, HistoryList } from '../../../interfaces/app.interface';
import { NgxFlickingComponent, NgxFlickingPanel } from '@egjs/ngx-flicking';

@Component({
  selector: 'app-history',
  imports: [TranslatePipe, NgxFlickingComponent, NgxFlickingPanel],
  templateUrl: './history.html',
  styleUrl: './history.scss'
})
export class History implements OnInit {
  @ViewChild(NgxFlickingComponent) flicking!: NgxFlickingComponent;
  public appService = inject(AppService);
  public historyRawList: HistoryList[] = [];
  public currentYear: string = '2025';

  public flickingOptions = {
    circular: false,
    align: 0,
    bound: true,
    inputType: ['touch', 'mouse', 'pointer']
  };

  get historyList(): HistoryItem[] {
    const historyList = this.historyRawList.find(member => member.language === this.appService.usedLanguage());
    if (historyList) {
      return historyList.list;
    }
    return [];
  }

  get historyListReverse(): HistoryItem[] {
    const historyList = this.historyRawList.find(member => member.language === this.appService.usedLanguage());

    if (historyList) {
      return [...historyList.list].reverse();
    }

    return [];
  }

  async ngOnInit() {
    this.historyRawList = await this.appService.getHistoryJsonData();
  }

  moveTo(year: string) {
    const index = this.historyListReverse.findIndex(h => h.year === year);
    if (index >= 0) {
      this.flicking.moveTo(index);
      this.currentYear = year;
    }
  }

  getNextYear(year: string) {
    const idx = this.historyListReverse.findIndex(h => h.year === year);
    return this.historyListReverse[idx + 1]?.year ?? '';
  }
}
